// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from 'react';

const MOBILE_MAX = 1023;

export default function useViewport(breakpoint = MOBILE_MAX) {
  const [width, setWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return {
    width,
    isMobile: width <= breakpoint
  };
}
